<template>
  <div>
    <h1>{{ isEdit ? '编辑商品' : '添加商品' }}</h1>

    <label for="name">名称：</label>
    <input type="text" id="name" v-model="formData.name"><br><br>

    <label for="image">图片：</label>
    <input type="file" id="image" ref="imageInput"><br>
    <div v-if="isEdit && existingImageUrl" class="image-preview">
      <img :src="existingImageUrl" alt="当前图片" width="100">
      <p>上传新图片将替换当前图片，不选择则保留原图</p>
    </div>
    <br>

    <label for="price">价格：</label>
    <input type="number" id="price" v-model="formData.price"><br><br>

    <label for="content">内容：</label>
    <textarea id="content" v-model="formData.content"></textarea><br><br>

    <button type="submit" @click="saveGoods">{{ isEdit ? '保存' : '添加' }}</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isEdit: false,
      productId: null,
      existingImageUrl: '',
      formData: {
        name: '',
        price: '',
        content: ''
      }
    };
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      this.isEdit = true;
      this.productId = id;
      this.loadProduct(id);
    }
  },
  methods: {
    loadProduct(id) {
      this.$http.get('/goods/goodsinfo', { params: { id } })
        .then(response => {
          if (response.data.code === 1 && response.data.data) {
            const data = response.data.data;
            this.formData.name = data.name;
            this.formData.price = data.price;
            this.formData.content = data.content;
            this.existingImageUrl = data.image;
          }
        })
        .catch(error => {
          console.error('加载商品信息失败:', error);
        });
    },
    saveGoods() {
      const formData = new FormData();
      formData.append('name', this.formData.name);
      formData.append('price', this.formData.price);
      formData.append('content', this.formData.content);

      if (this.isEdit) {
        formData.append('id', this.productId);
      }

      const imageFile = this.$refs.imageInput.files[0];
      if (imageFile) {
        formData.append('image', imageFile);
      }

      const method = this.isEdit ? 'put' : 'post';
      const url = this.isEdit ? '/goods/updategoods' : '/goods/addgoods';

      this.$http[method](url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        this.$toast(response.data.message);
        this.$router.go(-1);
      })
      .catch(error => {
        console.error('保存商品失败:', error);
      });
    }
  }
}
</script>

<style scoped>
.image-preview {
  margin-top: 5px;
}
.image-preview img {
  border: 1px solid #ddd;
  border-radius: 4px;
}
.image-preview p {
  color: #888;
  font-size: 12px;
}
</style>
